angular.module('app.directives.logo',[]).
directive('logo',
    [function(){
        'ngInject';

        return {
            scope:{

            },
            template:"<a class=\"logo-container logo-{{orgId}}\" href='' ng-click='goToMain()'> <img ng-src=\"images/logo-{{orgId}}.png\"></a>",
            controller : function($scope,$state,frontEndSettingsService){
                'ngInject';
                
                frontEndSettingsService.getFrontendSettings()
                .then(function(settings) {
                    $scope.orgId = settings.OrgId;
                });

                $scope.goToMain = () => {
                    $state.go('main');
                }
            }
        }

    }]
);
